import React from 'react';

import { useAdminPermissions } from 'src/hooks/useAdminPermissions';

type PermissionGuardProps = {
  permission?: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

const PermissionGuard: React.FC<PermissionGuardProps> = ({ permission, children, fallback = null }) => {
  const { can, loading, initialized } = useAdminPermissions();

  if (!initialized || loading) {
    return null;
  }

  if (!can(permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionGuard;
